import { Table } from 'antd';
import Column from 'antd/es/table/Column';
import { currencyFormat, formatVND } from '../../helpers/common';
import { ChiTietLuongThangItem, DynamicColumnHeader } from '../../models/luong/Luong';

const TableChiTietLuongThang = ({
    loading,
    dataSource,
    dynamicColumns,
}: {
    loading: boolean;
    dataSource: ChiTietLuongThangItem[];
    dynamicColumns?: DynamicColumnHeader[];
}) => {
    const salaryColumns = dynamicColumns || [];

    const getSalaryColumnKey = (col: DynamicColumnHeader) => `salary_${col.loai}_${col.id}`;

    return (
        <Table
            sticky
            pagination={false}
            scroll={{
                x: Math.max(900, 460 + salaryColumns.length * 150 + 260),
            }}
            loading={loading}
            bordered
            locale={{ emptyText: 'Không có dữ liệu' }}
            dataSource={(dataSource || []).map((x, idx) => ({ ...x, key: idx }))}
            summary={(pageData) => {
                let tongLuongDuocNhan = 0;
                let tongTienThueTNCN = 0;
                let tongLuongSauThue = 0;

                const dynamicTotals: { [key: string]: number } = {};

                salaryColumns.forEach((col) => {
                    dynamicTotals[getSalaryColumnKey(col)] = 0;
                });

                pageData.forEach((r) => {
                    salaryColumns.forEach((col) => {
                        const key = getSalaryColumnKey(col);
                        dynamicTotals[key] += r.dynamicColumns?.[key] ?? 0;
                    });

                    tongLuongDuocNhan += r.luongDuocNhan ?? 0;
                    tongTienThueTNCN += r.tienThueTNCN ?? 0;
                    tongLuongSauThue += r.luongSauThue ?? 0;
                });

                return (
                    <Table.Summary.Row>
                        <Table.Summary.Cell index={0} colSpan={3} align="center">
                            <label>TỔNG CỘNG</label>
                        </Table.Summary.Cell>

                        {salaryColumns.map((col, index) => {
                            const key = getSalaryColumnKey(col);

                            return (
                                <Table.Summary.Cell
                                    key={key}
                                    index={index + 3}
                                    align="right"
                                >
                                    <label>{formatVND(dynamicTotals[key])}</label>
                                </Table.Summary.Cell>
                            );
                        })}

                        <Table.Summary.Cell
                            index={salaryColumns.length + 3}
                            align="right"
                        >
                            <label>{formatVND(tongLuongDuocNhan)}</label>
                        </Table.Summary.Cell>

                        <Table.Summary.Cell
                            index={salaryColumns.length + 4}
                            align="right"
                        >
                            <label>{formatVND(tongTienThueTNCN)}</label>
                        </Table.Summary.Cell>

                        <Table.Summary.Cell
                            index={salaryColumns.length + 5}
                            align="right"
                        >
                            <label>{formatVND(tongLuongSauThue)}</label>
                        </Table.Summary.Cell>

                        <Table.Summary.Cell
                            index={salaryColumns.length + 6}
                            align="center"
                        />
                    </Table.Summary.Row>
                );
            }}
        >
            <Column
                fixed
                title="TT"
                width="60px"
                key="stt"
                align="center"
                render={(_v, _r, index) => index + 1}
            />

            <Column
                fixed
                title="Họ và tên"
                dataIndex="hoTen"
                key="hoTen"
                width="180px"
            />

            <Column
                title="Chức vụ hiện nay"
                dataIndex="tenChucVu"
                key="tenChucVu"
                width="160px"
                align="center"
            />

            {salaryColumns.map((col) => {
                const key = getSalaryColumnKey(col);

                return (
                    <Column
                        key={key}
                        title={col.name}
                        width="150px"
                        align="right"
                        render={(_v, record: ChiTietLuongThangItem) => {
                            const value = record.dynamicColumns?.[key] ?? 0;
                            return value ? currencyFormat.formatMoney(value) : '-';
                        }}
                    />
                );
            })}

            <Column
                title="Tổng thu nhập"
                dataIndex="luongDuocNhan"
                key="luongDuocNhan"
                width="160px"
                align="right"
                render={(v) => currencyFormat.formatMoney(v ?? 0)}
            />

            <Column
                title="Thuế TNCN"
                dataIndex="tienThueTNCN"
                key="tienThueTNCN"
                width="150px"
                align="right"
                render={(v) => (v ? currencyFormat.formatMoney(v) : '-')}
            />

            <Column
                title="Thực nhận sau thuế"
                dataIndex="luongSauThue"
                key="luongSauThue"
                width="170px"
                align="right"
                render={(v) => (v ? currencyFormat.formatMoney(v) : '-')}
            />

            <Column
                title="Ghi chú"
                dataIndex="ghiChu"
                key="ghiChu"
                width="120px"
            />
        </Table>
    );
};

export default TableChiTietLuongThang;